import React from 'react'
import Modal from 'components/shared/modal'
import PropTypes from 'prop-types'

const RemoveGuestModal = ({ onClose, onSubmit, guestType, bookingTime, bookingSpace }) => {
  switch (guestType) {
    case 'activeGuest':
    case 'bookedGuest':
      return (
        <Modal onClose={onClose} headerClose={false} contentClassName="py-10 px-12">
          <div className="font-semibold text-lg mb-2">Remove guest?</div>
          <div>
            <p>This will cancel all future bookings</p>
            <p className="text-sm text-gray-600">You will be able to re-invite guest when you remove them</p>
          </div>
          <div className="flex mt-5 gap-2">
            <button
              className="btn border border-primary-orange text-primary-orange flex-1 rounded px-8 py-3 font-medium text-center"
              onClick={onClose}
            >
              No
            </button>
            <button
              className="btn bg-primary-orange text-white flex-1 rounded px-8 py-3 font-medium text-center"
              onClick={() => {
                onSubmit()
                onClose()
              }}
            >
              Yes, remove guest
            </button>
          </div>
        </Modal>
      )
    case 'bookingGuest':
      return (
        <Modal onClose={onClose} headerClose={false} contentClassName="py-10 px-12">
          <div className="font-semibold text-lg mb-2">Remove guest?</div>
          <p>
            You are not allowed to remove this guest because they have booking on <strong>{bookingTime}</strong> at <strong>{bookingSpace}</strong>
          </p>
          <p>You will be able to remove them after this booking</p>
          <div className="flex mt-5 justify-center">
            <button
              className="btn bg-primary-orange text-white flex-1 rounded px-8 py-3 font-medium text-center"
              onClick={onClose}
            >
              Ok, got it
            </button>
          </div>
        </Modal>
      )
      case 'pendingGuest':
        return (
          <Modal onClose={onClose} headerClose={false} contentClassName="py-10 px-12">
            <div className="font-semibold text-lg mb-2">Remove guest?</div>
            <p>You will be able to re-invite guest when you remove them</p>
            <div className="flex mt-5 justify-center gap-2">
              <button
                className="btn border border-primary-orange text-primary-orange flex-1 rounded px-8 py-3 font-medium text-center"
                onClick={onClose}
              >
                No
              </button>
              <button
                className="btn bg-primary-orange text-white flex-1 rounded px-8 py-3 font-medium text-center"
                onClick={() => {
                  onSubmit()
                  onClose()
                }}
              >
                Yes, remove guest
              </button>
            </div>
          </Modal>
        )

    default:
      return null
  }
}

RemoveGuestModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  guestType: PropTypes.string.isRequired,
  bookingTime: PropTypes.string,
  bookingSpace: PropTypes.string,
}

export default RemoveGuestModal
